import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
//import { ModalEmailService } from './modal-comments.service';
declare var $:any;

@Component({
    selector: 'modal-comments',
    templateUrl: 'modal-comments.html'
})

export class ModalCommentsComponent implements OnInit {
    @Input() showModal;
    @Input() data;
    @ViewChild('emailModal') public officeModal:ModalDirective;
    @Output() emitCloseModal = new EventEmitter();
    public textCopied = '';
    public copyLabelText ={
        propose: "Copiar",
        confirm: "Copiar"
    }
    constructor() { }

    public onHidden():void{
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public closeModal():void{
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public setCommentType(comment: any) {
        if(comment.type == "reload") return 'c-comment';
        else if(comment.type == "cancel") return 'c-comment--alert';
        else if(comment.type == "user") return 'c-comment--user';
        else if(comment.type == "incidence") return 'c-comment--alert';
        else return 'c-comment';
    }

    public copyText(id: string) {
        this.textCopied = id;
        this.copyLabelText[id] = "Copiado";
        setTimeout(() =>{
            this.textCopied = '';
            this.copyLabelText[id] = "Copiar";
        }, 800);
        
        var valueToCopy = document.getElementById(id);
        var range = document.createRange();
            range.selectNode(valueToCopy);
            window.getSelection().addRange(range);

        try{
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful'; 
        
        } catch(err){
            console.log('Oops, unable to copy'); 
        }

          window.getSelection().removeAllRanges(); 
    }

    ngOnChanges(value) {
        
        (this.showModal) ? this.officeModal.show() : this.officeModal.hide();
    }
    ngOnInit() {}
}


// WEBPACK FOOTER //
// ./src/app/common/modal-comments/modal-comments.component.ts